import classNames from "classnames";
import { CR_SCORE, HT_FT, HT_FT_OE, TTG } from "../../constants/common";
import { BetPriceType, Option } from "../../types/common";

export type BettingTeamNameProps = {
  isHomeGoodTeam: boolean;
  isAwayGoodTeam: boolean;
  home: string;
  away: string;
  betPriceType: BetPriceType;
  option?: Option;
  outcomeId?: string;
};

const BettingTeamName = (props: BettingTeamNameProps) => {
  switch (props.betPriceType) {
    case "oe":
      if (props.option === 0) {
        return <div className="italic font-semibold">Odd</div>;
      }
      return <div className="italic font-semibold">Even</div>;
    case "ou":
    case "ou1st":
    case "tob":
    case "tob1st":
    case "ato":
    case "hto":
      if (props.option === 0) {
        return <div className="italic font-semibold">Over</div>;
      }
      return <div className="italic font-semibold">Under</div>;
    case "1h/cr":
    case "2h/cr":
    case "cr":
      return (
        <div className="italic font-semibold">
          {CR_SCORE[props.outcomeId ?? ""]}
        </div>
      );
    case "1h/ttg":
    case "ttg":
      return (
        <div className="italic font-semibold">{TTG[props.outcomeId ?? ""]}</div>
      );
    case "ht/ft/oe":
      return (
        <div className="italic font-semibold">
          {HT_FT_OE[props.outcomeId ?? ""]}
        </div>
      );
    case "ht/ft":
      return (
        <div className="italic font-semibold">
          {HT_FT[props.outcomeId ?? ""]}
        </div>
      );
    case "yn":
    case "hwn":
    case "awn":
      if (props.option === 0) {
        return <div className="italic font-semibold">Yes</div>;
      }
      return <div className="italic font-semibold">No</div>;
    default:
      if (props.option === 0) {
        return (
          <div
            className={classNames("italic font-semibold", {
              "text-red-500": props.isHomeGoodTeam,
            })}>
            {props.home}
          </div>
        );
      } else if (props.option === 1) {
        return (
          <div
            className={classNames("italic font-semibold", {
              "text-red-500": props.isAwayGoodTeam,
            })}>
            {props.away}
          </div>
        );
      }
      return <div>Draw</div>;
  }
};

export default BettingTeamName;
